import { gql } from "@apollo/client";
import { PRODUCT_ID_FIELDS } from "../fragments/product";

export const FIND_LABELS = gql`
  query FindLabels($filters: LabelFilterInput) {
    labels(filters: $filters) {
      _id
      name
      slug
      category
      color
      description
      collectionName
      isActive
      createdBy {
        _id
        firstName
        lastName
      }
      createdAt
      updatedAt
    }
  }
`;

export const FIND_LABELS_SERVER_SIDE = gql`
  query FindLabelsServerSide($input: ServerQueryInput) {
    labelsServerSide(input: $input) {
      pageInfo {
        currentPage
        pageSize
        totalDocuments
        totalPages
      }
      labels {
        _id
        name
        slug
        category
        color
        description
        collectionName
        isActive
        createdBy {
          _id
          firstName
          lastName
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export const FIND_LABEL_BY_ID = gql`
  query FindLabelById($labelId: ID!) {
    labelById(labelId: $labelId) {
      _id
      name
      slug
      category
      color
      description
      collectionName
      isActive
      createdBy {
        _id
        firstName
        lastName
      }
      createdAt
      updatedAt
    }
  }
`;

export const FIND_LABELS_BY_CATEGORY = gql`
  query FindLabelsByCategory($category: String!) {
    labelsByCategory(category: $category) {
      _id
      name
      slug
      category
      color
      description
      collectionName
      isActive
      createdBy {
        _id
        firstName
        lastName
      }
      createdAt
      updatedAt
    }
  }
`;

export const FIND_LABEL_BY_SLUG = gql`
  query FindLabelBySlug($slug: String!, $category: String) {
    labelBySlug(slug: $slug, category: $category) {
      _id
      name
      slug
      category
      color
      description
      collectionName
      isActive
      createdBy {
        _id
        firstName
        lastName
      }
      createdAt
      updatedAt
    }
  }
`;

const ASSET_BY_LABEL_FIELDS = `
  _id
  assetName
  assetType
  owner {
    _id
  }
  denormalized {
    donorName
    productName
  }
  ${PRODUCT_ID_FIELDS}
`;

export const FIND_ASSETS_BY_LABEL = gql`
  query FindAssetsByLabel($labelId: ID!) {
    assetsByLabel(labelId: $labelId) {
      ... on AccountAsset { ${ASSET_BY_LABEL_FIELDS} }
      ... on CryptoAsset { ${ASSET_BY_LABEL_FIELDS} }
      ... on EquityAsset { ${ASSET_BY_LABEL_FIELDS} }
      ... on EquitySourceAsset { ${ASSET_BY_LABEL_FIELDS} }
      ... on FundAsset { ${ASSET_BY_LABEL_FIELDS} }
      ... on LendingAsset { ${ASSET_BY_LABEL_FIELDS} }
      ... on OtherAsset { ${ASSET_BY_LABEL_FIELDS} }
      ... on RecoverableGrantAsset { ${ASSET_BY_LABEL_FIELDS} }
      ... on InternalAccountAsset { ${ASSET_BY_LABEL_FIELDS} }
      ... on OpportunityAsset { ${ASSET_BY_LABEL_FIELDS} }
    }
  }
`;

export const FIND_USERS_BY_LABEL = gql`
  query FindUsersByLabel($labelId: ID!) {
    usersByLabel(labelId: $labelId) {
      ... on DonorUser {
        _id
        friendlyId
        firstName
        lastName
        email
        type
        role
      }
      ... on FirmUser {
        _id
        friendlyId
        firstName
        lastName
        email
        type
        role
      }
      ... on InternalUser {
        _id
        friendlyId
        firstName
        lastName
        email
        type
        role
      }
      ... on EntityUser {
        _id
        friendlyId
        firstName
        lastName
        email
        type
        role
      }
    }
  }
`;
